import { render } from "./ArticleTile.vue?vue&type=template&id=8c892c16&scoped=true"
import script from "./ArticleTile.vue?vue&type=script&lang=js"
export * from "./ArticleTile.vue?vue&type=script&lang=js"

import "./ArticleTile.vue?vue&type=style&index=0&id=8c892c16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c892c16"]])

export default __exports__